// extracted by mini-css-extract-plugin
export default {"socialNetworkList":"HOmwj","button":"LE5bN","facebook":"b16m9","twitter":"nnSji","blog":"dNnmX"};